import api from '../api/v1'
import { pollSuggestedCourses, PollCancelledError } from '../utils/pollSuggestedCourses'

let activeSuggestedCoursesPoll = null

export const cancelActiveSuggestedCoursesPoll = () => {
  activeSuggestedCoursesPoll?.cancel()
  activeSuggestedCoursesPoll = null
}

const getSuggestedCoursesErrorMessage = (error, fallbackMessage) => {
  if (error instanceof PollCancelledError || error?.name === 'PollCancelledError') {
    return null
  }

  return error.response?.data?.errors[0] || fallbackMessage
}

export const fetchSuggestedCoursesWithPolling = async suggestRequest => {
  const { data } = await suggestRequest()
  const taskId = data?.taskId

  if (!taskId) {
    throw new Error('Brak identyfikatora zadania w odpowiedzi serwera')
  }

  const poll = pollSuggestedCourses(api.getSuggestedCourses, taskId)
  activeSuggestedCoursesPoll = poll

  try {
    return await poll.promise
  } finally {
    if (activeSuggestedCoursesPoll === poll) {
      activeSuggestedCoursesPoll = null
    }
  }
}

export const handleSuggestedCoursesFetchError = ({ error, dispatch, fallbackMessage }) => {
  const message = getSuggestedCoursesErrorMessage(error, fallbackMessage)

  if (!message) {
    return { cancelled: true }
  }

  dispatch('snackbar/showSnackbar', { message: [message], type: 'error' }, { root: true })

  return { cancelled: false, message }
}
